import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { getTotalCountFromHeader, isFunction, isStringTrimNotEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import React, { useEffect } from 'react';
import { useDrillDownReportColumns } from '../hooks/useDrillDownReportColumns';

function DrillDownReport({ 
    queries,
    isDrillDownReportVisible,
    setIsDrillDownReportVisible: setIsDrillDownReportVisible_props,
    selectedDealerDrillDown,
    setSelectedDealerDrillDown: setSelectedDealerDrillDown_props
}) {
    let setIsDrillDownReportVisible = isFunction(setIsDrillDownReportVisible_props)? setIsDrillDownReportVisible_props:() => {};
    let setSelectedDealerDrillDown = isFunction(setSelectedDealerDrillDown_props)? setSelectedDealerDrillDown_props:() => {};

    const {
        getInvoiceCommissionDrillDownList_requesting, invoiceCommissionDrillDownList,
        invoiceCommissionDrillDownListHeader
    } = useCustomSelector("reporting");

    const { 
        getInvoiceCommissionDrillDownList = () => {} 
    } = useReporting();

    const {
        userPermissions
    } = useCustomSelector("userManagementReducers");

    const columns = useDrillDownReportColumns();

    return (
        <DashboardLayout
            headerTitle={selectedDealerDrillDown}

            bodyClassName={"invoice-commission-drill-down"}
            body={(
                <GeneralTable
                    className={"invoice-commission-drill-down__table"}
                    columns={columns}
                    data={userPermissions?.Internal_DealerReport_View? invoiceCommissionDrillDownList: []}
                    getTableData={(currentPage, pageSize, sort, filterOptions) => {
                        getInvoiceCommissionDrillDownList(currentPage, pageSize, undefined, queries.current);
                    }}

                    isTableDataLoading={getInvoiceCommissionDrillDownList_requesting}
                    isTableRefreshRequired={isDrillDownReportVisible}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(invoiceCommissionDrillDownListHeader)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}

            isHeaderCloseIconVisible
            onClose={() => {
                setSelectedDealerDrillDown(undefined);
            }}
            updateParentState_visiblity={setIsDrillDownReportVisible}
        />
    );
}

export default DrillDownReport;